/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from '@emotion/react';
import { Avatar } from '@mui/material';
import { getColorFromPhone } from '../../utils/colors';
import { getTextInitials } from '../../../../../shared/utils/get-text-inititals';
import { StatusIndicator } from '../../../../../shared/components/atoms/status-indicator';
import { ChatType } from '../../components/chat-list-section/chat-row/typings';
import { AgentStatus } from '../../../../agent-availability/typings';

export interface AgentAvatarProps {
  name: string;
  phone?: string;
  size?: number;
  /** Show the online/offline status badge */
  showBadge?: boolean;
  isOnline?: boolean;
  badgeSize?: number;
  avatarCss?: SerializedStyles;
}

export const AgentAvatar = ({
  name,
  phone = '',
  size = 28,
  showBadge = false,
  isOnline = false,
  badgeSize = 8,
  avatarCss,
}: AgentAvatarProps) => {
  const color = getColorFromPhone({ phone, name, chatType: ChatType.INDIVIDUAL });
  const initials = getTextInitials(name).substring(0, 2);

  return (
    <div
      css={css`
        position: relative;
        flex-shrink: 0;
        width: ${size}px;
        height: ${size}px;
      `}
    >
      <Avatar
        css={css(
          css`
            width: ${size}px;
            height: ${size}px;
            font-size: ${Math.round(size * 0.43)}px;
            font-weight: 600;
            color: ${color};
            background-color: ${color}32;
            text-transform: uppercase;
          `,
          avatarCss
        )}
      >
        {initials}
      </Avatar>
      {showBadge && (
        <StatusIndicator
          status={isOnline ? AgentStatus.ONLINE : AgentStatus.OFFLINE}
          size={badgeSize}
          bottom={0}
          right={0}
        />
      )}
    </div>
  );
};
